<template>
  <v-row class="pt-5 pb-4">
    <number-picker
      :value="bookingGroupBookingsCount"
      label="Antal bokningar"
      @input="setBookingGroupBookingsCount"
    ></number-picker>

    <div
      v-for="(bookingGroupBooking, index) in bookingGroup.bookings"
      :key="bookingGroupBooking.clientId"
      class="full-width"
      @click="setActiveBookingGroupBookingIndex(index)"
    >
      <booking-group-booking-card
        :index="index"
        :booking="bookingGroupBooking"
        :active-booking-group-booking-index="activeBookingGroupBookingIndex"
        :is-show-map="isShowMap"
        :is-regular-booking="isRegularBooking"
        :show-map-button="showMapButton"
        :show-cancellation-policy-picker="!bookingGroup.sameCancellationPolicyForAllBookings"
        :show-date-picker="!bookingGroup.sameDatesForAllBookings"
        @toggle-map="toggleMap"
        @set-position-validation="setPositionValidation"
      ></booking-group-booking-card>
    </div>
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import BookingGroupBookingCard from '@/components/booking/form/BookingGroupBookingCard.vue'
import NumberPicker from '@/components/common/NumberPicker.vue'

export default {
  name: 'BookingFormGroupSection',
  components: {
    BookingGroupBookingCard,
    NumberPicker
  },
  props: {
    isShowMap: Boolean,
    showMapButton: Boolean
  },
  computed: {
    ...mapState('bookingForm', {
      activeBookingGroupBookingIndex: 'activeBookingGroupBookingIndex',
      bookingGroup: 'bookingGroupDraft'
    }),
    ...mapGetters('bookingForm', {
      bookingGroupBookingsCount: 'bookingGroupBookingsCount',
      isRegularBooking: 'isRegularBooking'
    })
  },
  methods: {
    ...mapActions('bookingForm', {
      setActiveBookingGroupBookingIndex: 'setActiveBookingGroupBookingIndex',
      setBookingGroupBookingsCount: 'setBookingGroupBookingsCount'
    }),
    toggleMap: function () {
      this.$emit('toggle-map')
    },
    setPositionValidation: function (validation) {
      this.$emit('set-position-validation', validation)
    }
  }
}
</script>
